import { Button, message } from 'antd';
import React, { useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import '../../index.css';
import { useHistory } from 'react-router-dom';
import { theme } from '../../constants/theme';
import { User } from '../../slices/auth';
import { Donor } from 'src/slices/donor';
import { FullscreenSpin } from '../../components/FullscreenSpin';

const useStyles = createUseStyles({
  stepContainer: {
    paddingBottom: '3rem',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'white',
  },
  stepColLeft: {
    width: '40%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: '0',
    left: '0',
    overflow: 'hidden',
  },
  stepBackgroundImage: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    minHeight: '100%',
  },
  stepColRight: {
    width: '60%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    marginLeft: '40vw',
    position: 'relative',
  },
  stepImage: {
    width: '100%',
  },
  stepBar: {
    height: '1vw',
    backgroundColor: theme.palette.primary,
  },
  buttonContainer: {
    marginTop: '3vw',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  buttonDashboardContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: '1rem',
  },
  buttonDashboard: {
    width: '15vw',
    height: '2.8vw',
    fontSize: '0.8vw',
    color: 'grey',
    marginTop: '6vw',
  },
  buttonNext: {
    width: '24vw',
    height: '2.8vw',
    fontSize: '1vw',
    border: `1px solid ${theme.palette.primary}`,
    backgroundColor: 'white',
    color: theme.palette.primary,
    borderRadius: '0.5vw',
    '&:hover': {
      border: `1px solid ${theme.palette.primary}`,
      backgroundColor: theme.palette.primary,
      color: 'white',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
    },
  },
  infos: {
    marginLeft: '3rem',
    marginRight: '3rem',
    marginTop: '9vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  title: {
    fontSize: '1.6vw',
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: '1.1vw',
    marginLeft: '2rem',
    marginRight: '2rem',
    textAlign: 'center',
  },
});

interface Props {
  user: User;
  displayedDonor: Donor;
  setIsNavBarHidden?: (isNavBarHidden: boolean) => void;
}

const DonorFirstProject: React.VFC<Props> = ({
  user,
  displayedDonor,
  setIsNavBarHidden,
}) => {
  const history = useHistory();
  const classes = useStyles();

  useEffect(() => {
    if (setIsNavBarHidden) {
      setIsNavBarHidden(true);
    }
  }, []);

  const onClickNewProject = () => {
    if (user?.role === 'admin') {
      history.push(`/donor/${displayedDonor?._id}/saveTenderDonor`);
    } else {
      if (
        displayedDonor?.callForTenders?.length &&
        user?.maxNumberOfProjects &&
        displayedDonor?.callForTenders?.length >= user.maxNumberOfProjects
      ) {
        message.error(
          user.maxNumberOfProjects === 1
            ? 'Vous ne pouvez pas créer plus de ' +
                user.maxNumberOfProjects +
                ' projet'
            : 'Vous ne pouvez pas créer plus de ' +
                user.maxNumberOfProjects +
                ' projets',
        );
      } else {
        if (user?.donorId) {
          history.push(`/donor/${user?.donorId}/saveTenderDonor`);
        }
      }
    }
  };

  return displayedDonor.callForTenders?.length === 0 ? (
    <div className={classes.stepContainer}>
      <div className={classes.stepColLeft}>
        <img
          src="../images/firstProject.png"
          alt="First project background"
          className={classes.stepBackgroundImage}
        />
      </div>
      <div className={classes.stepColRight}>
        <div className={classes.stepBar} style={{ width: '100%' }}></div>
        <div className={classes.infos}>
          <div className={classes.title}>
            <p>Bienvenue chez Sonar !</p>
          </div>
          <div className={classes.subtitle}>
            <p>
              Votre organisation est désormais visible par les porteurs de
              projet. Renseignez dès à présent votre programme de soutien afin
              d’accéder aux porteurs de projet les plus pertinents.
            </p>
          </div>
        </div>
        <div className={classes.buttonContainer}>
          <Button
            type="default"
            className={classes.buttonNext}
            onClick={onClickNewProject}
          >
            Créer mon premier programme de soutien
          </Button>
        </div>
        <div className={classes.buttonDashboardContainer}>
          <Button
            type="link"
            className={classes.buttonDashboard}
            onClick={() => history.push(`/callForTenders`)}
          >
            Accéder au tableau de bord
          </Button>
        </div>
      </div>
    </div>
  ) : (
    <FullscreenSpin />
  );
};

export default DonorFirstProject;
